import { ICONS } from '@/constants/constants'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

const footerLinks = [
  {
    heading: 'About Us',
    links: [
      { label: 'Our History', href: '/our-history' },
    ],
  },
  {
    heading: 'Help',
    links: [
      { label: 'FAQs', href: '/faq' },
      { label: 'Contact Us', href: '/contact-us' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms of Service', href: '/terms-services' },
    ],
  },
];

const socialLinks = [
  { icon: ICONS.facebookfooter, label: 'Facebook', href: 'https://www.facebook.com/laxkwalaamsband' },

  { icon: ICONS.instagram, label: 'Instagram', href: 'https://www.instagram.com/laxkwalaamsband/' },
];
const GuestFooter = () => {
  return (
    <footer className="bg-[#201211] text-white pt-8 pb-4 px-4 md:px-8 lg:px-16 w-full font-work-sans">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 lg:gap-12">
          {/* Logo and Social - Hidden on mobile, first column on desktop */}
          <div className="hidden md:flex flex-col items-start">
            <Image src={ICONS.vodo} alt='vodo' width={90} height={90} className="mb-3" />
            <span className="text-xs text-gray-300 mb-4 leading-relaxed">Proudly supported by Lax Kw'alaams</span>
            <div className="flex gap-4 mt-1">
              {socialLinks.map((s, i) => (
                <a target='_blank' key={s.label} href={s.href} aria-label={s.label} className="hover:opacity-80 transition-opacity">
                  <Image src={s.icon} alt={s.label} width={15} height={15} />
                </a>
              ))}
            </div>
          </div>

          {/* Render sections from footerLinks */}
          {footerLinks.map((section) => {
            const isAbout = section.heading === 'About Us'
            return (
              <div key={section.heading} className={` ${isAbout ? 'hidden md:flex' : 'flex'} flex-col`}>
                <div className={isAbout ? 'font-rakesly font-semibold mb-6 text-white text-base' : 'font-semibold mb-4 md:mb-6 text-white text-sm md:text-base font-rakesly'}>
                  {section.heading}
                </div>
                <ul className="space-y-2 text-gray-300">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link href={link.href} className={`hover:underline ${isAbout ? 'text-sm' : 'text-xs md:text-sm'} hover:text-white transition-colors`}>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )
          })}
        </div>
        
        {/* Divider - Hidden on mobile */}
        <hr className="hidden md:block border-t border-gray-700 my-6" />
        
        {/* Copyright */}
        <div className="text-center text-xs text-gray-300 mt-8 md:mt-0">© 2025 Lax Kw'alaams. All rights reserved.</div>
      </div>
    </footer>
  )
}

export default GuestFooter